'use client'

import React, { useEffect, useState } from 'react'
import { selectList } from '@/assets/data/filter'
import { Product } from '@/redux/services/catalogApi'
import { useGetVacanciesByFilterMutation, useGetVacancyFiltersQuery } from '@/redux/services/vacancyApi'

import Footer from '@/components/Footer/Footer'
import Filter from '@/components/filter/Filter'
import Header from '@/components/header/Header'
import CatalogPreloader from '@/components/catalog/CatalogPreloader'
import CatalogProdCard from '@/components/catalog/CatalogProdCard'
import VacancySort from '@/components/vacancy/VacancySort'
import VacancySortCurtain from '@/components/vacancy/VacancySortCurtain'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useTranslation } from 'react-i18next'


const VacancyModule = ({ data, filters }) => {
    const [curtainOpen, setCurtainOpen] = useState(false)
    const {t} = useTranslation()

    const [submitForm, filterResult] = useGetVacanciesByFilterMutation()
    const [filteredData, setFilteredData] = useState(data)
    const [count, setCount] = useState(10)
    const [page, setPage] = useState(0)
    const [isFilterFull, setIsFilterFull] = useState(false)

    const [searchValue, setSearchValue] = useState<string>('')
    const [vacancySpecialization, setVacancySpecialization] = useState<number[]>([])
    const [vacancyRegion, setVacancyRegion] = useState<number[]>([])

    const searchParams = useSearchParams()
    const router = useRouter()
    const pathname = usePathname()

    const { data: filtersList } = useGetVacancyFiltersQuery()

    const filterBody = {
        page: page,
        get: count,
        filters: {
            ...(searchValue && { title: searchValue }),
            ...(vacancySpecialization && vacancySpecialization.length && { vacancy_specializations: vacancySpecialization }),
            ...(vacancyRegion && vacancyRegion.length && { vacancy_regions: vacancyRegion }),
        }
    }

    useEffect(() => {
        const params = `${vacancySpecialization.length ? `&vacancy_specializations=` + vacancySpecialization.join(',') : ''}`
            + `${vacancyRegion.length ? `&vacancy_regions=` + vacancyRegion.join(',') : ''}`
            + `${searchValue ? `&title=` + searchValue : ''}`

        router.push(`${pathname}?${params.slice(1)}`, { scroll: false })

    }, [searchValue, vacancySpecialization, vacancyRegion, searchParams])

    useEffect(() => {
        const getParams = () => {
            if (searchParams.has('title') && !searchValue) {
                setSearchValue(searchParams.get('title'))
            }
            if (searchParams.has('vacancy_specializations') && !vacancySpecialization.length) {
                setVacancySpecialization([...searchParams.get('vacancy_specializations').split(',')?.map(Number)])
            }
            if (searchParams.has('vacancy_regions') && !vacancyRegion.length) {
                setVacancyRegion([...searchParams.get('vacancy_regions').split(',')?.map(Number)])
            }
        }
        getParams()
    }, [searchParams])

    useEffect(() => {
        submitForm(filterBody).then((filterData: any) => {

            if (Object.keys(filterBody.filters).length === 0) {
                setIsFilterFull(false)
            } else {
                setIsFilterFull(true)
            }
            setFilteredData(filterData.data)
        })

    }, [searchValue, vacancySpecialization, vacancyRegion, count])

    const specializationUpdate = (id: number) => {
        const updatedType = vacancySpecialization.includes(id) ?
            vacancySpecialization.filter(stateId => stateId !== id)
            :
            [...vacancySpecialization, id]

        setVacancySpecialization(updatedType)
    }

    const regionUpdate = (id: number) => {
        const updatedType = vacancyRegion.includes(id) ?
            vacancyRegion.filter(stateId => stateId !== id)
            :
            [...vacancyRegion, id]

        setVacancyRegion(updatedType)
    }

    const resetFilters = () => {
        setVacancySpecialization([])
        setVacancyRegion([])
    }

    


    return (
        <main className="vacancy">
            <Header
                isWhiteLogo={true}
                burgerBg={'#f3f6fe'} 
            />
            <div className="vacancy__content container">
                <div className="catalog__title-wrapper">
                    <h1 className={`catalog__title`}>{t('Vacancies')}</h1>
                </div>
                <div className='catalog__products'>
                    <div className='catalog__products-content'>
                        <Filter
                            vacancySpecs={vacancySpecialization}
                            vacancyRegion={vacancyRegion}
                            curtainOpen={curtainOpen}
                            vacancySearch={searchValue}
                            setVacancySearch={(str) => setSearchValue(str)}
                            setCurtainOpen={(state) => setCurtainOpen(state)}
                            selectList={selectList}
                        />
                        <VacancySortCurtain
                            resetFilters={resetFilters}
                            vacancyRegion={vacancyRegion}
                            vacancySpecialization={vacancySpecialization}
                            setVacancyRegion={(state) => regionUpdate(state)}
                            setVacancySpecialization={(state) => specializationUpdate(state)}
                            curtainOpen={curtainOpen}
                            setCurtainOpen={(state) => setCurtainOpen(state)}
                            filtersList={filtersList} />
                        <ul className='catalog__products-list'>
                            {
                                !filterResult.isSuccess ?
                                    Array(count).fill({})?.map(() => (
                                        <CatalogPreloader />
                                    ))
                                    :
                                    isFilterFull ?
                                        filteredData.items?.length ?
                                            filteredData.items?.map((vacancy: Product) => (
                                                <CatalogProdCard
                                                    linked={true}
                                                    key={vacancy.id}
                                                    item={vacancy}
                                                    vacancyCard={true}
                                                />
                                            ))
                                            :
                                            <h2 className='catalog__nothing-found'>По данному запросу ничего не найдено.</h2>
                                        :
                                        !filteredData.items?.length ?
                                            <h2 className='catalog__nothing-found'>Загрузка...</h2>
                                            :
                                            filteredData?.items?.map((product: Product) => (
                                                <CatalogProdCard
                                                    linked={true}
                                                    key={product.id}
                                                    item={product}
                                                    vacancyCard={true}
                                                />
                                            ))
                            }
                        </ul>
                        {data?.count > count &&
                            <button
                                onClick={() => setCount(count + 10)}
                                className='catalog__products-button button-more'
                            >
                                Загрузить еще
                            </button>}
                    </div>
                    <VacancySort
                        resetFilters={resetFilters}
                        vacancyRegion={vacancyRegion}
                        vacancySpecialization={vacancySpecialization}
                        setVacancyRegion={(state) => regionUpdate(state)}
                        setVacancySpecialization={(state) => specializationUpdate(state)}
                        filtersList={filtersList}
                        filters={filters}
                    />
                </div>
            </div>
            <Footer mapTheme='light' />
        </main>
    )
}

export default VacancyModule
